module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t1",
      "id": "c1"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#t1"
    }
  }, [_vm._v("Everything’s Blurry")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Each morning, David slipped from bed at 4:00 a.m.—quietly, so as not to wake me. He went to his home office across the hall and spent forty minutes in a series of exercises. He put on his headset and listened to “Sun Spirit” by Deuter or Chinese bamboo flute music as he performed his version of tai chi. It was his way of getting ready for the day. Then he showered, did a few chin-ups, and got dressed. Before he left for his lab, he would creep into our bedroom and leave a kiss on my cheek. Sometimes I pretended to be asleep. Sometimes I sleepily waved goodbye. Other times I pulled him down for just one more “real” kiss before he left. Then I would roll over, pull up the blankets, and wait for my alarm to ring at 5:50 a.m. It was his schedule, and it was mine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ever since 9/11, when overwhelming traffic into New York City turned a thirty-minute commute into a one- to two-hour nightmare, David began this unrealistic schedule. Rising early to beat the morning traffic and not returning home until well after rush hour—7:00 or 8:00 p.m.—was a very long day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On January 13, 2005, David’s morning started much the same as it did each day. The only difference was that he delayed his rising by one hour. He planned to work at home that morning, preparing a talk about his research that he expected "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("to deliver at Wesleyan University in Connecticut on Saturday. A long-time professor-friend was retiring from the faculty, and David was a featured speaker at his retirement symposium. It was an invitation and an honor that may have saved David’s life.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("If David’s morning had been routine, he would have been in his laboratory at Columbia University in New York City by 6:00 a.m.—long before his students arrived. If the morning had been routine, he would have been at his computer returning email, poring over recently collected data, and conducting business in his office, a beautiful room flanked by his two laboratories overlooking the George Washington Bridge on Manhattan’s Upper West Side. If the morning had been routine, I wouldn’t be writing this story. The morning was not routine, and that is why David lived through January 13th.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("I was dressed and had applied the finishing touches to my makeup—“Brush and apply,” as my friend Danielle always teased me. I looked at the clock. It was 7:00 a.m. "), _c('i', [_vm._v("I’m okay")]), _vm._v(", I thought. If I left by 7:20 a.m., I could make it to school with plenty of time to prepare. The children arrived at 8:40 a.m. I used to live in the same town where I taught first and third grade on alternate years. It was a roll-out-of-bed commute—only five minutes from school. So easy! But in 2001, David and I moved to a new home in a community fifty minutes away.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("I loved our new home, but I was not crazy about my commute. Half of it was highway driving, and the traffic could be unpredictable in the City area. A fifty-minute, no-traffic commute could take just that, or it could take up to ninety minutes. I always left extra time for snarls or accidents. Throw in an early morning Pupil Assistance Committee meeting or ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("a parent-teacher conference, and I had to leave even earlier. Thursday, January 13, 2005, started out as a relatively normal day. I planned to leave by 7:20 a.m. But I didn’t.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Just after 7:00 a.m., David stumbled into our bedroom. His hand covered his right eye. “I can’t see!” he cried, panic in his voice. “Everything’s blurry!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Pain etched his face as he collapsed on the bed. When he removed his hand, his right eye was filled with blood. He told me he had been doing chin-ups. He did thirteen of them—one more than he had done the day before. That’s David—always pushing, trying to surpass his last accomplished goal, only to surpass that achievement the next time. I remember thinking, "), _c('i', [_vm._v("Why? Why did you have to do one more? Why wasn’t twelve enough? Or ten or even five?")]), _vm._v(" But it wasn’t enough. It never was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to call the paramedics. I had the phone in my hand. It was like a lifeline, but David refused to let me call. He wanted to wait a few more minutes to see if his pain subsided. He sat at the edge of the bed, continuing to cover his eye. Soon the pain spread. I told him to tell me what was happening in case I had to tell a doctor. The pain spread down his cheek, then through his forehead. As it intensified, it moved quickly to the back of his head, and I would wait no longer. He agreed. I dialed 9-1-1.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dispatcher sounded bored. I guess after hearing emergency calls day and night, the essence of emergency wears off, and anyhow, it wasn’t "), _c('i', [_vm._v("her")]), _vm._v(" emergency. It wasn’t "), _c('i', [_vm._v("her")]), _vm._v(" husband who was suffering. To me, the call was surreal. It seemed to be matter-of-fact, business-as-usual for her. “What is the nature of your emergency?” she asked (sip of coffee). “What is your address?” (bite of bagel). If we had been talking about the weather, there would have been more emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Can you believe it’s been raining for two weeks?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I know! Make it stop!”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The dispatcher showed no emotion, and my emotion soared off the scale. It would have been helpful if she had shown some compassion, even pretended to understand the crisis David and I were trapped in.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "href": "http://Dictionary.com",
      "id": "AQq",
      "target": "_blank"
    }
  }, [_vm._v("Dictionary.com")]), _vm._v(" defines “emergency” as “a sudden, urgent, usually unexpected occurrence or occasion requiring immediate action.” I wanted immediate action, but the paramedics were not magically at the door as soon as I dropped the receiver into the cradle. I wrapped my arms around David, who was writhing and groaning in pain on the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They’re coming, David. They’re coming. Everything’s going to be all right. Just hang on, David. I love you so much. I love you. I love you!” I spouted this litany like a broken record.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If love or words could have made a difference, the emergency would have ended immediately. Love was not enough, and it didn’t end. David kept saying variations of “Donna, I love you. My life has been good. We’ve had a good life. I love you!” And he added, “Tell the kids I love them too . . . and Treska and Kaya. Everything you need is in the file. The papers are in the file.” The papers! I didn’t want to hear about papers. That was too serious. The papers meant only one thing: David didn’t think he would come home again. I couldn’t let my mind go there. I wouldn’t listen. I had a general idea of where the papers were, but I wanted nothing to do with them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“David, I don’t need the papers! Don’t worry about that. Everything’s going to be okay. I love you!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where were the paramedics? I ran to the window. No sign of them. Panic struck me—I had forgotten to give the dispatcher the gate code. It was too early for the guard to be on duty. How would they get in? I dialed 9-1-1 again. Same dispatcher. (I hope she finished her bagel.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sorry to interrupt again, but I forgot to tell you the code to "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("the gate.” I rattled off the numbers. It didn’t occur to me that emergency vehicles would have access to the code at the gate. But they surely didn’t have access to my front door, and it was locked. I ran down two sets of stairs in our brownstone-like townhouse. Slipping and sliding would be a better description, as I took the stairs two at a time. When I nearly tripped on the first staircase, I realized I had better slow down. I would be no help to David with a twisted ankle, but I needed to get to the door. I wanted to leave the door open, so the paramedics could rush in and take charge.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("By the time I got back upstairs, David writhed on the bed, moaning, and sweat poured from his body. I could do nothing but rub his arm and try to comfort and reassure him that everything was going to be all right. But I didn’t believe it. I had never been so scared. Though he was the one in physical danger and pain, I saw my life draining away. We had lived a normal life, and now we were sharing a tragedy.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaaf0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 81
// module chunks = 0